import React from 'react';

import PropTypes from 'prop-types';

import { HomePageHeaderSubLink } from './HomePageHeaderSubLink';

import './css/HamburgerMenuComponent.sass';

export const HamburgerMenuComponent = ({ navRoot, navLinks, installer }) => {
  const closeMenu = () => {
    const menu = document.getElementById('hamburg');
    if (menu.checked === true) {
      menu.checked = false;
    }
  };

  return (
    <div className="hamburger-menu-container">
      <div className="row">
        <input type="checkbox" id="hamburg" />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="hamburg" htmlFor="hamburg">
          <span className="line" />
          <span className="line" />
          <span className="line" />
        </label>
        <div className="hamburger-menu-label">Menü</div>

        <div className="hamburger-menu-list">
          <HomePageHeaderSubLink
            name={navRoot.title}
            link={navRoot.url}
            key={navRoot.title}
            closeMenu={closeMenu}
            installer={installer}
          />
          {navLinks.map((link) => (
            <HomePageHeaderSubLink
              name={link.title}
              link={link.url}
              key={link.title}
              closeMenu={closeMenu}
              installer={installer}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
HamburgerMenuComponent.propTypes = {
  navRoot: PropTypes.object.isRequired,
  navLinks: PropTypes.array.isRequired,
  installer: PropTypes.object,
};

HamburgerMenuComponent.defaultProps = {
  installer: null,
};
